import { DateTime } from 'luxon';
import { FirmatariList, SignatoriesVM, SoggettoList } from 'civil-status/view-models/step-form';
import { CodStateSignature } from 'civil-status/constants/cod-state-signature';

export const transformerSignatories = (
  values: Array<SoggettoList>,
  valuesFirmatariList: Array<FirmatariList>
): Array<SignatoriesVM> => {
  if ((values || []).length === 0) {
    return [];
  }

  return (values || [])?.map((item) => {
    const currentFirmatario = (valuesFirmatariList.find(
      (itemFirmatari) => itemFirmatari.key?.idSoggetto === item.key.idSoggetto
    ) || {}) as FirmatariList;

    return {
      name: item.nome || '',
      surname: item.cognome || '',
      dateBorn: item.dataNascita ? DateTime.fromISO(item.dataNascita) : null,
      fiscalCode: item.codiceFiscale || '',
      gender: item.sesso || '',
      email: currentFirmatario?.emailNotificaFirma || '',
      isSend: Boolean(currentFirmatario?.idPresaVisione),
      isVerify: currentFirmatario.codStatoFirma === CodStateSignature.Verified,
      isAutografa: !Boolean(currentFirmatario?.emailNotificaFirma),
      idPresaVisione: currentFirmatario?.idPresaVisione?.toString() || '',
      idSubject: item.key?.idSoggetto,
    } as unknown as SignatoriesVM;
  });
};
